import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const SystemRow = ({ system }) => {
  return (
    <tr>
      <td>{system.systemId}</td>
      <td>
        <Link to={'/systems/' + system.id}>{system.systemName}</Link>
      </td>
      <td>{system.systemState}</td>
      <td>{system.systemType}</td>
      <td>{system.isActive ? 'Yes' : 'No'}</td>
    </tr>
  );
};

SystemRow.propTypes = {
  system: PropTypes.object.isRequired,
};

export default SystemRow;



// WEBPACK FOOTER //
// ./src/components/system/SystemRow.js